import { Controller } from "@hotwired/stimulus"

const TEMPLATES = {
  npc: `<h2>Overview</h2>
<p></p>
<h2>Background</h2>
<p></p>
<h2>Personality</h2>
<p></p>
<h2>Relationships</h2>
<p></p>
<h2>Story Role</h2>
<p></p>`,

  pc: `<h2>Background</h2>
<p></p>
<h2>Personality</h2>
<p></p>
<h2>Goals &amp; Motivations</h2>
<p></p>
<h2>Key Relationships</h2>
<p></p>`,

  location: `<h2>Overview</h2>
<p></p>
<h2>Description</h2>
<p></p>
<h2>Notable Features</h2>
<p></p>
<h2>Inhabitants</h2>
<p></p>
<h2>History</h2>
<p></p>`,

  settlement: `<h2>Overview</h2>
<p></p>
<h2>Description</h2>
<p></p>
<h2>Notable Locations</h2>
<p></p>
<h2>Factions &amp; Power</h2>
<p></p>
<h2>History</h2>
<p></p>`,

  dungeon: `<h2>Overview</h2>
<p></p>
<h2>Rooms &amp; Areas</h2>
<p></p>
<h2>Hazards</h2>
<p></p>
<h2>Loot</h2>
<p></p>`,

  encounter: `<h2>Setup</h2>
<p></p>
<h2>Enemies</h2>
<p></p>
<h2>Terrain &amp; Tactics</h2>
<p></p>
<h2>Rewards</h2>
<p></p>`,

  creature: `<h2>Description</h2>
<p></p>
<h2>Abilities</h2>
<p></p>
<h2>Tactics</h2>
<p></p>
<h2>Lore</h2>
<p></p>`,

  item: `<h2>Description</h2>
<p></p>
<h2>Properties</h2>
<p></p>
<h2>History &amp; Origin</h2>
<p></p>`,

  spell: `<h2>Description</h2>
<p></p>
<h2>Higher Levels</h2>
<p></p>
<h2>Notes</h2>
<p></p>`,

  lore: `<h2>Overview</h2>
<p></p>
<h2>Details</h2>
<p></p>
<h2>Connections</h2>
<p></p>`,

  organisation: `<h2>Overview</h2>
<p></p>
<h2>Goals &amp; Methods</h2>
<p></p>
<h2>Key Members</h2>
<p></p>
<h2>History</h2>
<p></p>`,

  session: `<h2>Summary</h2>
<p></p>
<h2>Key Events</h2>
<p></p>
<h2>NPCs Encountered</h2>
<p></p>
<h2>Loose Ends</h2>
<p></p>`,
}

const SPEAKING_KINDS = new Set(["npc", "pc", "creature", "organisation", "protagonist", "antagonist"])

export default class extends Controller {
  static targets = ["kindSelect", "voiceRow"]

  connect() {
    const trixEl = this.element.querySelector("trix-editor")
    if (trixEl) {
      if (trixEl.editor) {
        this._editor = trixEl.editor
      } else {
        trixEl.addEventListener("trix-initialize", () => { this._editor = trixEl.editor }, { once: true })
      }
    }
  }

  kindChanged() {
    const kind = this.kindSelectTarget.value

    if (this.hasVoiceRowTarget) {
      this.voiceRowTarget.classList.toggle("hidden", !SPEAKING_KINDS.has(kind))
    }

    if (!this._editor) return
    const template = TEMPLATES[kind]
    if (!template) return
    const isEmpty = this._editor.getDocument().toString().trim() === ""
    if (!isEmpty) return
    this._editor.loadHTML(template)
  }
}
